import { AttendanceReasons } from './form/enum/AttendanceReasons.enum';

export const ATTENDANCE_REQUEST_TYPE = 'Attendance Request';

export const allowedReasonsTechnicalIssue: Record<string, boolean> = {
  [AttendanceReasons.DEVICE_NOT_ACCEPTING]: true,
};
